module.exports = __webpack_public_path__ + "img/eyeicon.d8cde3c4.svg";